<ng-container *ngIf="isVisible">
    <div *ngIf="mode !== UserAvatarMode.dropdown"
         class="user-avatar-list-item-wrapper">
        <button *ngIf="isOverflowButton"
                class="user-avatar-list-item
                               user-avatar-list-item--overflow
                               user-avatar-list-item--{{ mode }}">
            <span *ngIf="!dropdownIsOpen">{{ text }}</span>
            <span *ngIf="dropdownIsOpen"
                  class="dropdown-toggle"></span>
        </button>
        <img *ngIf="user && !isOverflowButton"
             class="user-avatar-list-item
                            user-avatar-list-item--{{ mode }}
                            user-avatar-list-item--{{ user.colorIndex }}"
             tooltip="{{ user?.name }}"
             placement="bottom"
             [style.transform]="'translateX(' + translateX + 'px)'"
             [src]="user.avatarUrl"/>
    </div>
    <div *ngIf="mode === UserAvatarMode.dropdown"
         class="user-avatar-list-item__dropdown-row">
        <img class="user-avatar-list-item
                        user-avatar-list-item--{{ user.colorIndex }}"
             [src]="user.avatarUrl"/>
        <div class="user-avatar-list-item__dropdown-name">
            {{ user.name }}
        </div>
    </div>
</ng-container>
